import { useMutation } from '@tanstack/react-query';

import createCrudService from '@core/api/create-crud-service';
import { request } from '@src/core/api/request';
import { queryClient } from '@src/core/api/query-client';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';
import { showToast } from '@src/shared/utils/helpers/show-toast';

import type { TCreatePlacementData } from '@shared/forms/types/placement';
import type { TBaseQuery } from '@shared/types/base-query';
import type { TPlacement } from '@shared/types/placement';

export type TPlacementsQuery = {
  host?: number;
  program?: (number | string)[];
  participant?: string;
} & TBaseQuery;

const placementApi = {
  ...createCrudService<TPlacement, TPlacementsQuery, TCreatePlacementData>({
    queryKey: [QUERY_KEYS.getPlacements],
    url: 'placements',
    validateQuery: [QUERY_KEYS.getPlacementApplications],
  }),

  useDuplicate: () => {
    return useMutation({
      mutationFn: ({
        ids,
        program,
      }: {
        ids: (number | string)[];
        program: number | string;
      }) =>
        request<TPlacement[]>({
          url: 'placements/duplicate/',
          method: 'POST',
          body: { placements: ids, program },
        }),
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (query) => query.queryKey[0] === QUERY_KEYS.getPlacements,
        });
        showToast({
          title: 'Duplicate Success',
          description: 'Placements have been duplicated successfully',
          variant: 'success',
        });
      },
    });
  },
};

export default placementApi;
